
import { onMounted } from 'vue'

export default {
  name: 'WidgetTwitter',

  setup() {
    onMounted(() => {
      if (!document.getElementById('twitter-wjs')) {

        const script = document.createElement('script')
        script.id = 'twitter-wjs'
        script.charset = 'utf-8'
        script.src = 'https://platform.twitter.com/widgets.js'

        const tl = document.querySelector('#twitter_tl')
        if (tl) {
          tl.appendChild(script)
        }
      }
    })
  }
}
